import { jsx as _jsx } from "react/jsx-runtime";
export const withLinkComponent = (target, rel) =>
// eslint-disable-next-line react/display-name
props => {
  const {
    children,
    ...rest
  } = props;
  return /*#__PURE__*/_jsx("a", {
    target: target,
    rel: rel || target === '_blank' ? 'noopener noreferrer' : rel,
    ...rest,
    children: children
  });
};